import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-feedback', 'MIN_RATE', 'Сложно');
Labels.set('ui-feedback', 'MAX_RATE', 'Просто');
Labels.set('ui-feedback', 'POSITIVE', 'Да');
Labels.set('ui-feedback', 'NEGATIVE', 'Нет');
Labels.set('ui-feedback', 'CONFIRM', 'Отправить');
Labels.set(
    'ui-feedback',
    'TEXTAREA_LABEL',
    'Что мы можем улучшить или сделать иначе?'
);
Labels.set(
    'ui-feedback',
    'HINT_MESSAGE',
    'Этот опрос является анонимным. Мы будем использовать результаты для развития наших услуг.'
);
Labels.set('ui-feedback', 'SUCCESS_MESSAGE', 'Спасибо за Ваш отзыв!');
Labels.set('ui-feedback', 'ERROR_MESSAGE', 'Feedback sending failed');
